import { EmptyFolder } from '@/assets/illustration'

/**
 * DriveEmptyState
 *
 * Displayed when the current folder has no children (folders or files).
 */
export function DriveEmptyState() {
  return (
    <div className="flex flex-col items-center justify-center gap-4 py-10">
      <EmptyFolder className="h-10 w-auto shrink-0" aria-hidden />
      <p className="text-center text-sm font-medium leading-5 tracking-[-0.15px] text-brand-neutral-600">This folder is empty</p>
    </div>
  )
}
